/**
 * 2018.08.04
 * 企业申请表，授权书
 */

import ApiPort from '../config/api-port';
import HttpAxios from './http-axios';
import GlobalConfig from '../config/global';
import {handleError, handleResponse} from '../lib/common';
import qs from 'qs';

const StatelessPrefix = '/si/adp/v1';
const junziqianApi = GlobalConfig.domain.junziqianApi;

export default {
// 下载授权书模板
  applyFile(param) {
    return HttpAxios.download(junziqianApi + ApiPort.applyTableController.applyFile, param);
  },
  // 下载授权书模板1.0
  downApplyTableRq(param) {
    return HttpAxios.download(junziqianApi + ApiPort.applyTableController.downApplyTable, param);
  },
  // 下载授权书模板 2.0 (api认证时调用)
  StatelessDownApplyTableRq(param) {
    return HttpAxios.download(junziqianApi + StatelessPrefix + ApiPort.applyTableController.downApplyTable, param);
  },
  // 下载数字证书申请表 (api非大陆个人认证时调用)
  manualTableDownRq(param) {
    return HttpAxios.download(junziqianApi + '/si/adp/v1/i/idenAuth/v2/downNonChineseApplyTable', param);
  },
  /**
   * 提交申请表,返回表url地址,注意:
   *  1.调用此接口前,必须为企业用户,个人没有申请表
   *  2.调用此接口前,企业必须通过高级认证
   *  3.调用此接口只针对用户登录使用,不适用于签署
   *  4.没有提交过申请表
   * @param file
   * @returns {Promise<T>}
   */
  commit(file) {
    let url = junziqianApi + ApiPort.applyTableController.commit;
    let formData = new FormData();
    formData = formData.append('file', file);

    return HttpAxios.postForm(url, formData).then(handleResponse).catch(handleError);
  },

  /**
   * 查看申请表审核状态,success:true通过|false没通过+原因;个人时直接返回true
   *  1.调用此接口前,必须为企业用户,个人没有申请表
   *  2.调用此接口前,企业必须通过高级认证
   *  3.调用此接口只针对用户登录使用,不适用于签署
   * @returns {Promise<T>}
   */
  approveStatus() {
    let url = junziqianApi + ApiPort.applyTableController.approveStatus;

    return HttpAxios.post(url, {}).then(handleResponse).catch(handleError);
  },

  /**
   * 查看申请表记录,注意:
   *  1.调用此接口前,必须为企业用户,个人没有申请表
   *  2.调用此接口前,企业必须通过高级认证
   *  3.调用此接口只针对用户登录使用,不适用于签署
   * @returns {Promise<T>}
   */
  applyTable() {
    let url = junziqianApi + ApiPort.applyTableController.applyTable;

    return HttpAxios.post(url, {}).then(handleResponse).catch(handleError);
  },
};



// WEBPACK FOOTER //
// ./assets/js/http-serve/applyTableController.js